// extracted by mini-css-extract-plugin
export default {"grid":"ListGrid_grid__40v1Z","header":"ListGrid_header__ZVyQQ","body":"ListGrid_body__3tKpW"};